@if (!isUsedInHierarchy) {
  <abp-card class="zn-crud-page">
    <abp-card-body>
      <app-crud-page
        #crudPage
        [tableName]="config.localizationKey"
        [permission]="config.permission"
        [fields]="fields"
        [dataset]="dataset()"
        [loading]="loading()"
        [loadData]="loadData"
        [actions]="actions"
        [hideCreateButton]="true"
        (createRecord)="create()"
        (deleteRecord)="deleteRecords()"
        (editRow)="edit($event)"
        (saveInMemoryRequested)="onSaveInMemory($event)"
        (selectedItemsChange)="onRowSelection($event)"
        (exportToExcelRecord)="exportToExcel()"
      ></app-crud-page>
    </abp-card-body>
  </abp-card>
} @else {
  <app-crud-page
    #crudPage
    [tableName]="config.localizationKey"
    [permission]="config.permission"
    [fields]="fieldsWithChevron()"
    [dataset]="dataset()"
    [loading]="loading()"
    [actions]="actions"
    [loadData]="loadData"
    (createRecord)="create()"
    (deleteRecord)="deleteRecords()"
    (editRow)="edit($event)"
    (saveInMemoryRequested)="onSaveInMemory($event)"
    (selectedItemsChange)="onRowSelection($event)"
    (exportToExcelRecord)="exportToExcel()"
  ></app-crud-page>
}

<app-generic-form
  #genericForm
  (payload)="save($event)"
></app-generic-form>
